import { Box, Card, Grid, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { useAtomValue } from 'jotai';
import { PageWrapper } from '../common/components/PageWrapper';
import ContextImage from '../topMenu/ContextImage';
import { getCompanyShortName } from '../common/utils/common.utils';
import { ellipsisStyle } from '../common/utils/style.utils';
import { currentContextAtom } from '../state';
import UserCompanyNavigation from './UserCompanyNavigation';
import { Business_Profile_Enum } from '@kheops/graphql';

export default function UserCompanyPage(): React.JSX.Element {
  const context = useAtomValue(currentContextAtom);

  return (
    <PageWrapper>
      <Grid
        container
        columnSpacing={2}
        sx={{
          height: {
            lg: 'calc(100vh - 120px)',
          },
        }}
      >
        <Grid
          size={{ xs: 3 }}
          sx={{
            height: '100%',
            display: {
              xs: 'none',
              lg: 'initial',
            },
          }}
        >
          <Card
            sx={{
              height: 'calc(100% - 48px)',
              overflow: 'auto',
              p: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 1,
                mt: 0.5,
              }}
            >
              <ContextImage context={context} size={context.realm === Business_Profile_Enum.Buyer ? 32 : 40} borderRadius={20} />
              <Typography variant="titleMedium" sx={{ ...ellipsisStyle }}>
                {getCompanyShortName(context.companyName, context.realm)}
              </Typography>
            </Box>
            <UserCompanyNavigation />
          </Card>
        </Grid>
        <Grid size={{ xs: 12, lg: 9 }} sx={{ height: '100%' }}>
          <Outlet />
        </Grid>
      </Grid>
    </PageWrapper>
  );
}
